module.exports = __webpack_public_path__ + "static/media/accept-payments.eac0e954.png";